import { CollectionView } from "backbone.marionette";

import { Report } from "./report";

export const ReportsList = CollectionView.extend({
    className: "inner",
    childView: Report,
    childViewTriggers: {
        "action:open": "action:open"
    },
    childViewOptions: {
        controls: false
    }
});
